import { useRef, useState } from "react";
import { Popover, Whisper } from "rsuite";
import { Button } from "reactstrap";
import ReadableFilter from "../../CRM/ReadableFilter";
import FilterDropdownMenu from "../../CRM/FilterDropdownMenu";
import SettingsGroup from "../../CRM/SettingsGroup";

const FiltersGroup = ({
  widget,
  updateSection,
  module,
  disabled,
  disabledComponent,
}) => {
  const [filterMode, setFilterMode] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const filterDropdownRef = useRef();

  const clearFilter = () => {
    let newQuery = { ...widget?.Query };

    if (!newQuery) {
      newQuery = {};
    }

    newQuery.Filters = [];

    updateSection("Query", newQuery);

    filterDropdownRef?.current?.close();
  };

  return (
    <SettingsGroup
      title="Filters"
      className="mb-2"
      disabled={disabled}
      disabledComponent={disabledComponent}
    >
      <ReadableFilter
        query={widget?.Query}
        moduleAPIName={widget?.ModuleAPIName}
      />
      <hr className="my-2"></hr>
      <Whisper
        preventOverflow
        placement="auto"
        trigger={filterMode === "quick" ? "click" : "none"}
        ref={filterDropdownRef}
        onOpen={() => setFilterOpen(true)}
        onClose={() => setFilterOpen(false)}
        speaker={
          <Popover
            className="sidebar-popover"
            full
            style={{ width: "100%", maxWidth: 650 }}
          >
            <FilterDropdownMenu
              showVariables
              currentModule={module}
              query={widget?.Query}
              onApply={(newQuery) => {
                const query = { ...widget?.Query };

                query.Filters = newQuery?.Filters ?? [];

                updateSection("Query", query);

                filterDropdownRef.current.close();
              }}
              onClear={clearFilter}
              onModeChange={(mode) => {
                setFilterMode(mode);
              }}
              onClose={() => {
                filterDropdownRef?.current?.close();
              }}
              checkForFields={false}
            />
          </Popover>
        }
      >
        <Button
          size="sm"
          className="my-2"
          color="secondary"
          outline
          onClick={() => {
            filterOpen
              ? filterDropdownRef?.current?.close()
              : filterDropdownRef?.current?.open();
          }}
        >
          <i
            className="mdi mdi-filter-outline mr-1"
            style={{
              fontSize: 16,
              lineHeight: 1,
              top: 2,
              position: "relative",
            }}
          ></i>
          Apply Filters
        </Button>
      </Whisper>
    </SettingsGroup>
  );
};

export default FiltersGroup;
